var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.inWeiXin())?_c('x-header',{attrs:{"left-options":_vm.leftOptions}},[_vm._t("default",[_vm._v(_vm._s(_vm.title))]),_vm._t("right",null,{"slot":"right"})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }